import { supabase } from '../supabase';

/**
 * P1 (2026-09-24) — `get_my_access_status()` is a SECURITY DEFINER RPC (DB
 * lane, separate migration) that inspects the CALLER's own tenant_memberships
 * WITHOUT the active-membership / active-tenant filters
 * `getTenantMembershipForUser` applies (tenantContextLoaders.js). That lets
 * it tell apart "your own account was deactivated" from "your company's
 * account was deactivated" — a distinction the filtered loader collapses
 * into one bucket (both resolve to `{ role: null, tenantId: null }`). It
 * returns only the caller's own status + their own company's name — never
 * another user's or another tenant's data (enforced server-side; see the
 * migration + its pgTAP).
 *
 * This sits on the revocation path, so the contract is strict: NEVER throw,
 * and hand the caller `null` for anything it doesn't fully recognize — a
 * missing RPC (this may ship before the DB lane's migration lands on a given
 * environment), a network error, or a payload shape that isn't exactly what's
 * expected. Every caller's rule is "null means fall back to today's
 * behavior" (see syncSession.js).
 */
const VALID_STATUSES = new Set(['ok', 'tenant_inactive', 'member_inactive', 'invite_pending', 'none']);

export async function getMyAccessStatus() {
  try {
    const { data, error } = await supabase.rpc('get_my_access_status');
    if (error || !data || typeof data !== 'object' || Array.isArray(data)) {
      return null;
    }
    const { status, tenant_name: tenantName } = data;
    if (typeof status !== 'string' || !VALID_STATUSES.has(status)) {
      return null;
    }
    return { status, tenantName: typeof tenantName === 'string' ? tenantName : null };
  } catch (_err) {
    return null;
  }
}
